// import Vue from "vue"
// import router from "@/router"
import { make } from "vuex-pathify"
// import { Toast } from "buefy/dist/components/toast"
import EstimateProxy from "@/proxies/EstimateProxy"

const state = {
  estimateLines: []
}

const mutations = make.mutations(state)

const actions = {
  async all({ commit }, estimateId, params = {}) {
    let response = await new EstimateProxy(params).allLines(estimateId)
    commit("SET_ESTIMATE_LINES", response)
  },

  async update({ dispatch }, { estimateId, data, params = {} }) {
    let response = await new EstimateProxy(params).updateLines(estimateId, data)
    await dispatch("all", estimateId)
    return response
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
